// NOTES
//-------------------------------------------------------------------------------------------------------------------------
//
// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewEncapsulation, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';

//Third Party
import moment from 'moment';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { WebServices } from '../../shared/services/webServices';
import { CPDFormatters } from '../../shared/services/cpd-formatters';

//Bootstrap
import { casNgbDateParserFormatter } from '../../shared/services/cas-NgbDateParserFormatter';

//Library
import { BCGrowls } from '../../shared/library/bcGrowls';
import { CASValidate } from '../../shared/library/casValidate';

//Config/GLobals
import { Enums } from '../../shared/enums.js';

//Token
import { authToken } from '../../shared/authToken';
import { FormAction } from '../../shared/classes/formAction';
import { Helpers } from '../../shared/services/helpers';


// LOCALS
//-------------------------------------------------------------------------------------------------------------------------


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// AssetTypeAddComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
    selector: 'asset-type-add',
    template : '<div class="cpd-main-div" data-test-id="content_asset_type">\n\n    <!--Title-->\n    <h2 tabindex="-1" class="cpd-title-div">\n        {{_title}}\n    </h2>\n\n    <!--For 508-->\n    <div style="position:relative; top:-5px; left:10px;"><span style="color:#b70f0a;">*</span> indicates a required field</div>\n\n    <div style="height:10px;"></div>\n\n    <!--Content Loading -->\n    <div *ngIf="casNavBoxService.ActionsLoading" class="cpd-ui-content-loading">\n        <img src="public/cpd-images/loading.gif" />\n        <div style="margin-left:10px;">Loading...</div>\n    </div>\n\n    <!--Content Div -->\n    <div id="ata_main_content_div" style="margin:10px;" [style.display]="(!casNavBoxService.ActionsLoading) ? \'block\' : \'none\'">\n\n        <!-- Asset Type -->\n        <!-- ------------------------------------------------------------------------------------------------------------- -->\n        <div class="cpd-ui-row" data-test-id="section_asset_type">\n\n            <div class="cpd-ui-cell" style="flex-grow: 1;">\n\n                <div class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Asset Type</h3></div>\n\n                <div class="cpd-ui-field-div">\n                    <label for="asset_type_code" style="width:150px;">Asset Type Code<span class="cpd-required" aria-label="required">*</span></label>\n                    <input id="asset_type_code"\n                           name="asset_type_code"\n                           type="text"\n                           [attr.data-cval-msg-element-id]="\'asset_type_code_vmsg\'"\n                           [attr.data-cval-fld-name]="\'Asset Type Code\'"\n                           [attr.data-cval-required]="true"\n                           style="width:75px; text-transform: uppercase"\n                           class="cval "\n                           (input)="_formChanged($event)"\n                           maxlength="1"\n                           [ngModel]="_assetType?.typeCode" (ngModelChange)="_assetType.typeCode=$event" />\n                </div>\n                <!--validation message-->\n                <div id="asset_type_code_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                <div id="assetTypeCodeInUseMessage" *ngIf="_assetType?.typeCode && _practiceTypeCodesInUse.includes(_assetType?.typeCode.toUpperCase())" class="cval-validation-message" style="padding-left:10px;">Asset Type Code already in use</div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--asset_type_name-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div">\n                    <label for="asset_type_name" style="width:150px;">Asset Type Name<span class="cpd-required" aria-label="required">*</span></label>\n                    <input id="asset_type_name"\n                           name="asset_type_name"\n                           type="text"\n                           [attr.data-cval-msg-element-id]="\'asset_type_name_vmsg\'"\n                           [attr.data-cval-fld-name]="\'Asset Type Name\'"\n                           [attr.data-cval-required]="true"\n                           style="flex-grow:1;"\n                           class="cval "\n                           (input)="_formChanged($event)"\n                           maxlength="100"\n                           [ngModel]="_assetType?.typeName" (ngModelChange)="_assetType.typeName=$event" />\n                </div>\n                <!--validation message-->\n                <div id="asset_type_name_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--asset_type_display_name-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div">\n                    <label for="asset_type_display_name" style="width:150px;">Asset Type Display Name<span class="cpd-required" aria-label="required">*</span></label>\n                    <input id="asset_type_display_name"\n                           name="asset_type_display_name"\n                           type="text"\n                           [attr.data-cval-msg-element-id]="\'asset_type_display_name_vmsg\'"\n                           [attr.data-cval-fld-name]="\'Asset Type Display Name\'"\n                           [attr.data-cval-required]="true"\n                           style="flex-grow:1;"\n                           class="cval "\n                           (input)="_formChanged($event)"\n                           maxlength="50"\n                           [ngModel]="_assetType?.displayName" (ngModelChange)="_assetType.displayName=$event" />\n                </div>\n                <!--validation message-->\n                <div id="asset_type_display_name_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--asset_type_description-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div">\n                    <label for="asset_type_description" style="width:150px; align-self:flex-start;">Asset Type Description<span class="cpd-required" aria-label="required">*</span></label>\n                    <textarea id="asset_type_description"\n                              name="asset_type_description"\n                              rows="5"\n                              type="text"\n                              [attr.data-cval-msg-element-id]="\'asset_type_description_vmsg\'"\n                              [attr.data-cval-fld-name]="\'Asset Type Description\'"\n                              [attr.data-cval-required]="true"\n                              style="flex-grow:1;"\n                              class="cval "\n                              (input)="_formChanged($event)"\n                              maxlength="500"\n                              [ngModel]="_assetType?.assetTypeDescription" (ngModelChange)="_assetType.assetTypeDescription=$event">\n                    </textarea>\n                </div>\n\n                <!--validation message-->\n                <div id="asset_type_description_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--business_rule_description-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div">\n                    <label for="business_rule_description" style="width:150px; align-self:flex-start;">Business Rule Description<span class="cpd-required" aria-label="required">*</span></label>\n                    <textarea id="business_rule_description"\n                              name="business_rule_description"\n                              rows="5"\n                              type="text"\n                              [attr.data-cval-msg-element-id]="\'business_rule_description_vmsg\'"\n                              [attr.data-cval-fld-name]="\'Business Rule Description\'"\n                              [attr.data-cval-required]="true"\n                              style="flex-grow:1;"\n                              class="cval "\n                              (input)="_formChanged($event)"\n                              maxlength="255"\n                              [ngModel]="_assetType?.businessRuleDescription" (ngModelChange)="_assetType.businessRuleDescription=$event">\n                    </textarea>\n                </div>\n                <!--validation message-->\n                <div id="business_rule_description_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n\n\n                <!-- ---------------------------------------------------- -->\n                <!--create_business_rules-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div">\n                    <label for="create_business_rules" style="width:150px; align-self:flex-start;">Create Business Rules<span class="cpd-required" aria-label="required">*</span></label>\n                    <div id="create_business_rules">\n                        <input type="radio"\n                               checked\n                               id="none"\n                               name="business_rules"\n                               value="none"\n                               (click)="_setBusinessRules(\'none\')" />\n                        <label for="none">None</label>\n                        <br>\n                        <input type="radio"\n                               id="range"\n                               name="business_rules"\n                               value="range"\n                               (click)="_setBusinessRules(\'range\')" />\n                        <label for="range">Range</label>\n                        <input type="text"\n                               id="range_from"\n                               name="range_from"\n                               aria-label="From Range"\n                               *ngIf="_assetType.businessRules == \'range\'"\n                               maxlength="4"\n                               class="cval "\n                               [attr.data-cval-numeric]="true"\n                               [attr.data-cval-msg-element-id]="\'range_from_vmsg\'"\n                               [attr.data-cval-fld-name]="\'From Range\'"\n                               [attr.data-cval-required]="true"\n                               (input)="_formChanged($event)"\n                               [ngModel]="_assetType?.rangeFrom" (ngModelChange)="_assetType.rangeFrom=$event" />\n                        <span *ngIf="_assetType.businessRules == \'range\'">&nbsp;To&nbsp;</span>\n                        <input type="text"\n                               id="range_to"\n                               name="range_to"\n                               aria-label="To Range"\n                               *ngIf="_assetType.businessRules == \'range\'"\n                               maxlength="4"\n                               class="cval "\n                               [attr.data-cval-numeric]="true"\n                               [attr.data-cval-msg-element-id]="\'range_to_vmsg\'"\n                               [attr.data-cval-fld-name]="\'To Range\'"\n                               [attr.data-cval-required]="true"\n                               (input)="_formChanged($event)"\n                               [ngModel]="_assetType?.rangeTo" (ngModelChange)="_assetType.rangeTo=$event" />\n                        <!--validation messages-->\n                        <div id="range_from_vmsg" class="cval-validation-message" style="padding-left:10px; display:inline"></div>\n                        <div id="range_to_vmsg" class="cval-validation-message" style="padding-left:10px; display:inline"></div>\n                        <br>\n                        <input type="radio"\n                               id="starts_with"\n                               name="business_rules"\n                               value="starts_with"\n                               (click)="_setBusinessRules(\'starts_with\')" />\n                        <label for="starts_with">Starts with</label>\n                        <input type="text"\n                               id="starts_with"\n                               name="starts_with"\n                               *ngIf="_assetType.businessRules == \'starts_with\'"\n                               maxlength="5"\n                               style="text-transform: uppercase"\n                               class="cval "\n                               [attr.data-cval-msg-element-id]="\'starts_with_vmsg\'"\n                               [attr.data-cval-fld-name]="\'Starts With\'"\n                               [attr.data-cval-required]="true"\n                               (input)="_formChanged($event)"\n                               [ngModel]="_assetType?.startsWith" (ngModelChange)="_assetType.startsWith=$event" />\n                        <!--validation message-->\n                        <div id="starts_with_vmsg" class="cval-validation-message" style="padding-left:10px; display:inline"></div>\n                    </div>\n\n                </div>\n\n            </div>\n\n        </div>\n\n\n        <!--=====================================================================-->\n        <!-- Status / Dates -->\n        <!--=====================================================================-->\n        <div class="cpd-ui-row" data-test-id="section_practice_edit_states_an_dates" style="padding-bottom:20px;">\n\n            <div class="cpd-ui-cell" style="flex-grow:1;">\n                <div class="cpd-ui-group-lbl" role="heading" aria-level="3"><h3>Status</h3></div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--start_date-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div">\n                    <label for="start_date_selector" style="width:150px;">Start<span class="cpd-required" aria-label="required">*</span></label>\n                    <input type="date"\n                           [min]="_today"\n                           placeholder="m/d/yyyy"\n                           id="start_date_selector"\n                           name="start_date_selector"\n                           data-cval-msg-element-id="start_date_vmsg"\n                           [attr.data-cval-fld-name]="\'Activation Date\'"\n                           [attr.data-cval-required]="true"\n                           [attr.data-cval-date]="true"\n                           style="width:140px;"\n                           aria-label="Start date (format m/d/yyyy)"\n                           class="form-control cval "\n                           [ngModel]="_assetType?.start_date"\n                           (ngModelChange)="_assetType.start_date=$event; _formChanged()" />\n                    <!--validation message-->\n                    <div id="start_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                </div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--end_date-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div">\n                    <label for="end_date_selector" style="width:150px;">End</label>\n                    <input type="date"\n                           [min]="_today"\n                           placeholder="m/d/yyyy"\n                           id="end_date_selector"\n                           name="end_date_selector"\n                           data-cval-msg-element-id="end_date_vmsg"\n                           [attr.data-cval-fld-name]="\'Deactivation Date\'"\n                           [attr.data-cval-required]="false"\n                           [attr.data-cval-date]="true"\n                           style="width:140px;"\n                           aria-label="End date (format m/d/yyyy)"\n                           class="form-control cval"\n                           [ngModel]="_assetType?.end_date"\n                           (ngModelChange)="_assetType.end_date=$event; _formChanged()" />\n                    <!--validation message-->\n                    <div id="end_date_vmsg" class="cval-validation-message" style="padding-left:10px;"></div>\n                </div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--Publish-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div">\n                    <label for="publish" style="width:150px;">Publish</label>\n                    <input type="checkbox"\n                           id="publish"\n                           name="publish"\n                           value="publish"\n                           [ngModel]="_assetType?.publish" (ngModelChange)="_assetType.publish=$event" />\n                </div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--Manage Purposes-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div">\n                    <label for="manage_purposes" style="width:150px;">Manage Purposes</label>\n                    <input type="checkbox"\n                           id="manage_purposes"\n                           name="manage_purposes"\n                           value="Manage Purposes"\n                           [ngModel]="_assetType?.manage_purposes" (ngModelChange)="_assetType.manage_purposes=$event; _formChanged()" />\n                </div>\n\n                <!-- ---------------------------------------------------- -->\n                <!--FSA Asset-->\n                <!-- ---------------------------------------------------- -->\n                <div class="cpd-ui-field-div">\n                    <label for="fsa_practice" style="width:150px;">FSA Asset</label>\n                    <input type="checkbox"\n                           id="fsa_practice"\n                           name="fsa_practice"\n                           value="FSA Asset"\n                           [ngModel]="_assetType?.fsa_practice" (ngModelChange)="_assetType.fsa_practice=$event; _formChanged()" />\n                </div>\n\n            </div>\n\n        </div> <!--Status-->\n\n        <!--Popups-->\n        <!--====================================================================================================-->\n        <!--POPUP INSTANCE CONTAINER-->\n        <div id="asset_type_add_page_popups"></div>\n\n        <!--====================-->\n        <!-- Confirmation -->\n        <!--====================-->\n        <modal #popCancelChanges\n               containerId="asset_type_add_page_popups"\n               title="Cancel Changes"\n               label="popCancelChanges">\n\n            <!--FVT-ID-->\n            <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_asset_type_add_confirm_cancel"></section>\n\n            <!-- body -->\n            <section>\n                <div class="cpd-ui-row">\n                    <div class="cpd-ui-cell" style="width:100%">\n                        <div class="cpd-ui-field-div">\n                            Are you sure that you want to cancel your changes?\n                        </div>\n                    </div>\n                </div>\n            </section>\n\n            <!-- footer -->\n            <footer>\n                <button type="button" class="btn btn-primary" (click)="popCancelChanges.Close()">Stay on Page</button>\n                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="_navBackToAssetTypeManagement();">Discard Changes</button>\n            </footer>\n        </modal>\n\n    </div><!--Content-->\n   \n</div>\n',
    styles : ['input[type=radio]{margin-top:-1px;vertical-align:middle}'],
    providers: [],
    encapsulation: ViewEncapsulation.None //Allows child components to read the parent's styles
})
export class AssetTypeAddComponent {


    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('popCancelChanges') popCancelChanges;

    //Class wide member reference for the growls control
    growlBox = null;


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _assetType = {
        businessRules: 'none'
    };
    _dirty = false;
    _disposalFunctions = []; //For disposing subscriptions to rxjs observables
    _formName = 'Add_Asset_Type'; //Just a shortcut (also helpful for cut & paste)
    _title = "Add Asset Type";
    _valid = true;
    _attributeFlags = 0;
    _componentName = "AssetTypeAddComponent";
    _practiceTypeCodesInUse = [];

    //Tracking previous values
    _now = moment();
    _today = new Date().toISOString().substring(0, 10);

    // INITIALIZATION/LIFECYCLE
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(casNavBoxService: CASNavBoxService,
        ngbDateParser: casNgbDateParserFormatter,
        cpdFormatters: CPDFormatters,
        changeDetectorRef: ChangeDetectorRef,
        helpers: Helpers,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

        // Handle clicks on the NavBox actions
        //-------------------------------------------
        let disposer = casNavBoxService.OnActionClicked$.subscribe(action => {
            this._navBoxActionClicked(action);
        });
        this._disposalFunctions.push(disposer);

        //Prep the validation object
        this.casValidate = new CASValidate();

    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {
        console.log("\n[assetTypeAdd:ngOnInit()]------------------------------------------------------------------------");
        this.set508();
        this.initalizeGrowlBox();
        this.setNavBoxActions();
        this.performAsyncOperations();
    };

    //==================================
    // initalizeGrowlBox
    //==================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        for (var i = 0; i < this._disposalFunctions.length; i++) {
            this._disposalFunctions[i].unsubscribe();
        }
    };


    // UI MANAGEMENT FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            let el = document.getElementsByClassName("cpd-title-div")[0];
            if (el) { el.focus(); }
        }, 0);
    }

    //==================================
    // performAsyncOperations
    //==================================
    performAsyncOperations() {
        this.loadPracticeTypeCodes();
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        let actions = [];

        actions.push(new FormAction("act_cancel_asset_type", "Close"));

        switch (authToken.user.role) {
            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                actions.push(new FormAction("act_save_asset_type", "<u>S</u>ave Asset Type", true, null, "s"));
                break;

            default:
                break;
        }

        console.log(`[${this._componentName}:ngOnInit()] - actionLinks:`, actions);

        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;
    }

    //==================================
    // _disableUI
    //==================================
    // Disable all UI controls, including the navBox.
    _disableUI() {
        this.casNavBoxService.DisableAllLinks();
    };

    //==================================
    // _enableUI
    //==================================
    // Enable all UI controls, including the navBox.
    _enableUI() {
        this.casNavBoxService.EnableAllLinks();
    };

    //==================================
    // _formChanged
    //==================================
    _formChanged(event) {
        // Trigger change detection for DOM changes. This keeps the validation in sync when we show and
        // hide inputs using *ngIf. Otherwise, the validation still sees hidden inputs and doesn't see the 
        // newly shown inputs. It lags one event behind what's actually happening without it.
        this.changeDetectorRef.detectChanges();

        //Mark the form dirty if it isn't already
        if (!this._dirty) {
            this._setAssetTypeDirty();
        }

        //Check the form's validity
        let isValid = this.casValidate.isAllValid(true, "ata_main_content_div");
        if (isValid) {
            if (!this._valid) {
                this._setAssetTypeValid();
            }
        }
        else {
            //Form is invalid
            if (this._valid) {
                this._setAssetTypeInvalid();
            }
        }
    };

    //==================================
    // _setAssetTypeClean
    //==================================
    _setAssetTypeClean() {
        this._dirty = false;
        this.casValidate.markAllValid("ata_main_content_div");
    };

    //==================================
    // _setAssetTypeDirty
    //==================================
    _setAssetTypeDirty() {
        this._dirty = true;
    };

    //==================================
    // _setAssetTypeInvalid
    //==================================
    _setAssetTypeInvalid() {
        this._valid = false;
    };

    //==================================
    // _setAssetTypeValid
    //==================================
    _setAssetTypeValid() {
        this._valid = true;
    };

    //==================================
    // _navBoxActionClicked
    //==================================
    _navBoxActionClicked(action) {
        if (!action.__enabled) { return; }

        switch (action.field_name.toLowerCase()) {
            case "act_cancel_asset_type":
                if (this._dirty) {
                    this.popCancelChanges.Open(); //Calls navBackToList() if user agrees to discard changes
                }
                else {
                    this._navBackToAssetTypeManagement();
                }
                break;
            // SAVE ASSET TYPE
            //--------------------------------------
            case "act_save_asset_type":
                this._saveAssetType();
                break;

            default:
                console.log(`[addAssetType:_navBoxActionClicked()] Unsupported action: `, action);
        }

    };

    //==================================
    // _navBackToAssetTypeManagement
    //==================================
    _navBackToAssetTypeManagement() {
        this.router.navigate(["/cpdes/practices/assetTypes/"]);
    }

    //==================================
    // _saveAssetType
    //==================================
    _saveAssetType() {
        try {
            this._validateAssetType();
            this._createAssetType();
        }
        catch (e) {
            console.log(this.cpdFormatters.formatError(e));
            this.growlBox.addGrowl("error", "Asset type failed to create");
        }
    }

    //==================================
    // _validateAssetType
    //==================================
    _validateAssetType() {
        if (this._assetType.end_date) {
            if (this._assetType.end_date < this._assetType.start_date) {
                this.growlBox.addGrowl("error", "End Date must be after Start Date.");
                document.getElementById('cpd_content_div').scrollTop = 0;
                throw "error";
            }
        }

        if (!this._valid) {
            this.growlBox.addGrowl("error", "The form is not valid. Please complete all required fields and resolve any errors.");
            document.getElementById('cpd_content_div').scrollTop = 0;
            throw "error";
        }

        if (!this._dirty) {
            this.growlBox.addGrowl("error", "No changes have been detected.");
            document.getElementById('cpd_content_div').scrollTop = 0;
            throw "error";
        }
    }

    //==================================
    // _createAssetType
    //==================================
    _createAssetType() {
        this._disableUI();
        this.growlBox.addGrowl("info", "Saving new asset type...");
        let assetTypeForSave = this._prepAssetTypeForSave();
        console.log(`Saving assetType: `, assetTypeForSave);
        this.webServices.Post("/assetTypes/createAssetType", assetTypeForSave)
            .then((response) => {
                this._executeValidResponseActions(response);
            })
            .catch((err) => {
                this.growlBox.addGrowl("error", `An error occured while saving`);
                console.log(this.cpdFormatters.formatError(err));
            });
        document.getElementById('cpd_content_div').scrollTop = 0;
        this._enableUI();
    }

    //==================================
    // _executeValidResponseActions
    //==================================
    _executeValidResponseActions(response) {
        console.log("[assetTypeAdd:_createAssetType() - response:]", response);
        if (response.Success) {
            this._executeSuccessActions();
        }
        else {
            this._executeErrorActions(response);
        }
    }

    //==================================
    // _executeSuccessActions
    //==================================
    _executeSuccessActions() {
        this.growlBox.addGrowl("success", "Asset Type Created.");
        this._refreshPage();
    }

    //==================================
    // _refreshPage
    //==================================
    _refreshPage() {
        this._assetType = {
            typeCode: null,
            typeName: null,
            displayName: null,
            assetTypeDescription: null,
            businessRuleDescription: null,
            start_date: null,
            end_date: null,
            publish: null,
            manage_purposes: null,
            fsa_practice: null
        }
        this._setBusinessRules("none");
        this._setAssetTypeClean();
    }

    //==================================
    // _executeErrorActions
    //==================================
    _executeErrorActions(response) {
        if (response.ValidationErrors.length > 0) {
            this.growlBox.addGrowl("error", `There were validation errors`);
            console.log(this.cpdFormatters.formatValidationErrors(response.ValidationErrors));
        }
        else {
            this.growlBox.addGrowl("error", `An error occured while saving`);
            console.log(this.cpdFormatters.formatError(response));
        }
    }

    //==================================
    // _setBusinessRules
    //==================================
    _setBusinessRules(value) {
        this._clearBusinessRules();
        this._setAssetTypeClean();
        this._assetType.businessRules = value;
        this._formChanged();
    }

    //==================================
    // _clearBusinessRules
    //==================================
    _clearBusinessRules() {
        this._assetType.rangeFrom = '';
        this._assetType.rangeTo = '';
        this._assetType.startsWith = '';
    }

    //==================================
    // _prepAssetTypeForSave
    //==================================
    // Creates a copy of the assetType with fields prepared for saving to DB
    // Currently that only includes the data fields which are in a custom format since
    // I added the bootstrap calendar control.
    _prepAssetTypeForSave() {
        //Copy assetType
        let assetType = Object.assign({}, this._assetType);

        //Boolean prep
        assetType.publish = this._assetType.publish ? 'Y' : 'N';

        //Attribute flag for FSA/Purpose prep
        this._setAttributeFlags();
        assetType.attribute_flags = this._attributeFlags;

        //Convert NgbDateStruct fields to date fields
        assetType.start_date = this._assetType.start_date ? new Date(this._assetType.start_date).toISOString() : null;
        assetType.end_date = this._assetType.end_date ? new Date(this._assetType.end_date).toISOString() : null;

        //Ensure default for manage purposes
        //assetType.manage_purposes = assetType.manage_purposes || false;

        return assetType;
    };

    //==================================
    // _setAttributeFlags
    //==================================
    _setAttributeFlags() {

        let isPurpose = this._assetType.manage_purposes ? Enums.ATCFlags.MANAGE_PURPOSES : 0;
        let isFSAAsset = this._assetType.fsa_practice ? Enums.ATCFlags.FSA_PRACTICE : 0;
        this._attributeFlags = isPurpose | isFSAAsset;

    }

    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------
    //==================================
    // loadPracticeTypeCodes
    //==================================
    loadPracticeTypeCodes() {
        this.casNavBoxService.ActionsLoading = true;
        this._practiceTypeCodesInUse = [];

        this.webServices.Get({
            apiPath: "/practices/getPracticeTypeCodes",
            args: {
                fy: null,
                includeAll: true
            }
        })
            .then(res => {
                console.log("[{0}:/practices/getPracticeTypeCodes] - res:".format(this._componentName), res);
                let dto = res.data.DTO;

                //Errors in the callback trigger the catch for this service call (?!) and populate the alerts with errors the user shouldn't see.  Catch it here instead.
                try {
                    dto.forEach((practiceTypeCode) => this._practiceTypeCodesInUse.push(practiceTypeCode.practice_type_code));
                    console.log("Practice Type Codes in Use: ", this._practiceTypeCodesInUse);
                    //Hide the loading message
                    this.casNavBoxService.ActionsLoading = false;
                }
                catch (err) {
                    this.growlBox.addGrowl("error", "An unexpected error has occurred");
                    console.log("[ERROR][{0}:_loadGrid()]".format(this._componentName), err);

                    //Always hide the loading message on errors
                    this.casNavBoxService.ActionsLoading = false;
                }

            })
            .catch(err => {
                this.growlBox.addGrowl("error", this.cpdFormatters.formatError(err));

                //Always hide the loading message on errors
                this.casNavBoxService.ActionsLoading = false;
            });
    };

}
